export const indexOfMaxItemArray = (arr: number[]) => {
  if (arr.length === 0) {
    return -1;
  }

  let max = arr[0];
  let maxIndex = 0;

  arr.forEach((value, index) => {
    if (value > max) {
      maxIndex = index;
      max = value;
    }
  });

  return maxIndex;
};
